import { Action } from '@ngrx/store';
import { WithdrawAction } from '../models/action.model';
import { EditWithdrawTransaction } from '../../../transactions/transactions.types';

export enum TransactionsActions {
    InitTransactionTab = '[Transactions] Initialize Transaction Tab',
    SuccessGetTransaction = '[Transactions] Success get Transactions',
    UpdateTransaction = '[Update Transaction] Update Transaction',
    AddTransactionAction = '[Transaction Action] Add Transaction Action'
}

export class InitTransactionTab implements Action {
    readonly type = TransactionsActions.InitTransactionTab;
    constructor(public transactionId: string) {}
}

export class SuccessGetTransaction implements Action {
    readonly type = TransactionsActions.SuccessGetTransaction;
    constructor(
        public transactionId: string,
        public actions: WithdrawAction[]
    ) {}
}
export class UpdateTransaction implements Action {
    readonly type = TransactionsActions.UpdateTransaction;
    constructor(
        public transactionId: string,
        public status: string,
        public transaction: WithdrawAction
    ) {
    }
}

export class AddTransactionAction implements Action {
    readonly type = TransactionsActions.AddTransactionAction;

    constructor(
        public action: WithdrawAction,
        public transactionId: string
    ) {
    }
}

export type TransactionAction =
    | InitTransactionTab
    | SuccessGetTransaction
    | UpdateTransaction
    | AddTransactionAction;
